import { useFormikContext } from "formik";
import { handleChangeHelper } from "./formikCheckboxHelper";
import { useContext } from "react";
import FormikControlContext from "../../../Contexts/FormikControlContext";

function useFormikCheckBox() {
  const field = useContext(FormikControlContext);
  const { productName } = field;
  const formik = useFormikContext();

  const handleChange = (event) => {
    formik.handleChange(event);
    // Call helper function
    handleChangeHelper(event, productName, formik);
  };

  const handleBlur = (event) => {
    // Calling helper function
    // handleOnBlurHelper();
  };

  return { handleChange, handleBlur };
}

export default useFormikCheckBox;
